import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  ITrackingAction,
  ITrackingObject,
  ITrackingProperties,
} from 'i2g-ng-tracking';
import { IIcon } from '../icon/icon.component';
import { ButtonStyle } from '../../directives/button/button.directive';

@Component({
  selector: 'i2g-link',
  templateUrl: 'link.component.html',
  styleUrls: ['link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent implements OnInit {
  @Input() label: string;
  @Input() href: string;
  @Input() openInNewTab: boolean;
  @Input() icon: IIcon;
  @Input() inline = true;
  @Input() buttonStyle: ButtonStyle;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingAdditionalProperties: ITrackingProperties;

  constructor() {}

  ngOnInit() {}
}
